import { LoaderCircle } from 'lucide-react'

import { Logo } from 'src/shared/components/icons/logos/logo'
import ParticleSwarmLoader from 'src/shared/components/ui/animation/particle-swarm'
import { cn } from 'src/shared/utils/cn'

export type LoadingStyle = 'minimal' | 'centered' | 'fullscreen'

interface LoadingProps {
  style?: LoadingStyle
  className?: string
}

export const Loading = ({ style = 'minimal', className }: LoadingProps) => {
  if (style === 'minimal') {
    return (
      <div className={cn('w-full text-primary opacity-60 transition-opacity duration-200', className)}>
        <LoaderCircle />
      </div>
    )
  }

  if (style === 'centered') {
    return (
      <div className={cn('flex min-h-[200px] w-full items-center justify-center', className)}>
        <ParticleSwarmLoader color="secondary" />
      </div>
    )
  }

  // fullscreen
  return (
    <div className={cn('flex h-screen w-full flex-col items-center bg-transparent', className)}>
      <div className="flex flex-1 items-center justify-center">
        <ParticleSwarmLoader color="secondary" />
      </div>
      <div className="pb-16">
        <Logo className="w-96" />
      </div>
    </div>
  )
}
